import { useReadMineUserQuery } from '@/redux/user'
import { useAppSelector } from '@/redux/utils'

export default function useReadMineUserQueryWhenLogin() {
  const token = useAppSelector((state) => state.global.token)
  return useReadMineUserQuery(
    undefined,
    { skip: token === undefined },
  )
}
